export const CAMPAIGN_TYPES = [
  { value: "public_relations", label: "Public Relations" },
  { value: "brand", label: "Brand" },
  { value: "media", label: "Media" },
];

export const TARGET_AUDIENCES = [
  { value: "small_business", label: "Small Business" },
  { value: "corporate_companies", label: "Corporate Companies" },
  { value: "urban_apartment", label: "Urban Apartment" },
  { value: "business", label: "Business" },
];

export const CAMPAIGN_STATUSES = [
  { value: "open", label: "Open" },
  { value: "running", label: "Running" },
  { value: "complete", label: "Complete" },
]